import axios from "axios";

const API_URL = "https://billing.clafoutis.eu/api";
const TOKEN_KEY = "clafoutis_token";
const USER_KEY = "clafoutis_user";

export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
    try {
        return JSON.parse(localStorage.getItem(USER_KEY));
    } catch (e) {
        return null;
    }
}

export function isAuthenticated() {
    return Boolean(getToken());
}

export async function loginWithGoogleCredential(credential) {
    const {data} = await axios.post(`${API_URL}/auth/google`, {credential});
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    return data.user;
}

export function clearSession() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
}

export async function logout() {
    const token = getToken();
    clearSession();
    if (token) {
        try {
            await axios.post(`${API_URL}/auth/logout`, {}, {headers: {Authorization: `Bearer ${token}`}});
        } catch (e) {
            // Token already invalid server-side: nothing to revoke.
        }
    }
    window.location.href = "/login";
}

export async function getAccessTokenSilently() {
    const token = getToken();
    if (!token) {
        throw new Error("Not authenticated");
    }
    return token;
}

export function authGuard(to) {
    if (!isAuthenticated()) {
        return {name: "LoginView", query: {redirect: to.fullPath}};
    }
    return true;
}

export default {
    getToken,
    getUser,
    isAuthenticated,
    loginWithGoogleCredential,
    clearSession,
    logout,
    getAccessTokenSilently,
};
